const firebaseConfig = {
    apiKey: "AIzaSyCxukx8OvSb7FtG4IEa9xvWrIwTAKPgFlI",
    authDomain: "kids-care-auth.firebaseapp.com",
    projectId: "kids-care-auth",
    storageBucket: "kids-care-auth.appspot.com",
    messagingSenderId: "890848296089",
    appId: "1:890848296089:web:1550ef2bd35d3786738c08"
  };

  export default firebaseConfig;